import { render } from "./ExternalLogin.vue?vue&type=template&id=dacbba9c"
import script from "./ExternalLogin.vue?vue&type=script&lang=js"
export * from "./ExternalLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__